import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { BankAccount } from "../Entities/BankAccount/BankAccount";
import { BankAccountInterface } from "../Entities/BankAccount/BankAccountInterface";

class BankAccountFactory extends Factory implements FactoryInterface {

  public create(data: any): BankAccountInterface {
    return new BankAccount({
      id: data.id,
      contactId: data.contactId,
      companyId: data.companyId,
      agencyId: data.agencyId,
      accountId: data.accountId,
      isDefault: data.isDefault,
      name: data.name ? data.name : "",
      removed: data.removed,
      label: data.label ? data.label : ""
    });
  }

  public reinitialize(data: any): BankAccountInterface {
    return new BankAccount({
      ...data
    });
  }
}

export default new BankAccountFactory();
